/**
 * Detection function for Object.hasOwn method
 * Returns true if Object.hasOwn is supported, false otherwise
 */
export default function () {
  return 'hasOwn' in Object
}
